import{a as o}from"./chunk.2AIXLGYE.js";import{a}from"./chunk.NFEB7TIJ.js";import{a as l}from"./chunk.VDLOD2KK.js";import{a as n}from"./chunk.65JZXZ5X.js";import{c as e}from"./chunk.NWIV65VP.js";import{html as g}from"lit";import{property as i,query as f,state as h}from"lit/decorators.js";import{classMap as u}from"lit/directives/class-map.js";import{css as m}from"lit";var c=m`
  ${o}

  :host {
    --ring-size: var(--he-spacing-2x-large);
    --track-width: 3px;
    --track-color: var(--he-color-primary-200);
    --indicator-color: var(--he-color-primary-600);
    --label-font-size: var(--he-font-size-small);
    --label-line-height: var(--he-line-height-medium);
    --label-color: var(--he-color-primary-600);
  }

  .progress-ring {
    display: inline-flex;
    gap: var(--he-spacing-x-small);
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .progress-ring--start {
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
  }

  .progress-ring--end {
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
  }

  .progress-ring--top {
    flex-direction: column-reverse;
  }

  .progress-ring__image {
    width: var(--ring-size);
    height: var(--ring-size);
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
  }

  .progress-ring__container {
    line-height: 1px;
  }

  .progress-ring__track,
  .progress-ring__indicator {
    --radius: calc(var(--ring-size) / 2 - var(--track-width) * 0.5);
    --circumference: calc(var(--radius) * 2 * 3.141592654);
    --indeterminate-chunk: calc(var(--radius) * 1.5);
    fill: none;
    stroke-width: var(--track-width);
    r: var(--radius);
    cx: calc(var(--ring-size) / 2);
    cy: calc(var(--ring-size) / 2);
  }

  .progress-ring__track {
    stroke: var(--track-color);
  }

  .progress-ring__indicator {
    stroke: var(--indicator-color);
    stroke-linecap: round;
    transition: 0.35s stroke-dashoffset;
    stroke-dasharray: var(--circumference) var(--circumference);
    stroke-dashoffset: calc(var(--circumference) - var(--percentage) * var(--circumference));
  }

  .progress-ring--indeterminate .progress-ring__indicator {
    stroke: var(--indicator-color);
    fill: none;
    stroke-linecap: round;
    transform-origin: 50% 50%;
    animation: spin-infinite 1s linear infinite;
    stroke-dasharray: var(--circumference) var(--circumference);
    stroke-dashoffset: calc(var(--circumference) - 0.2 * var(--circumference));
  }

  @keyframes spin-infinite {
    0% {
      transform: rotate(0deg);
    }
    50% {
      transform: rotate(180deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .progress-ring__indicator_indeterminate {
    stroke: var(--indicator-color);
    fill: none;
    stroke-width: var(--track-width);
    stroke-linecap: round;
    transform-origin: 50% 50%;
    transform: rotate(-90deg);
    transition: all 0.2s ease-in-out;
    animation: spin-infinite 2s linear infinite;
  }

  .progress-ring__label {
    width: 100%;
    height: 100%;
    text-align: center;
    user-select: none;
    font-size: var(--label-font-size);
    line-height: var(--label-line-height);
    color: var(--label-color);
  }

  /* High contrast */
  @media screen and (forced-colors: active) {
    .progress-ring__track {
      stroke: ${a.HighlightText};
    }

    .progress-ring--indeterminate .progress-ring__indicator,
    .progress-ring__indicator {
      stroke: ${a.Highlight};
    }
  }
`;var r=class extends n{constructor(){super(...arguments);this.hasSlotController=new l(this,"[default]");this.value=0;this.label="";this.indeterminate=!1;this.labelPlacement="bottom"}updated(t){if(super.updated(t),t.has("percentage")){let p=parseFloat(getComputedStyle(this.indicator).getPropertyValue("r")),s=2*Math.PI*p,d=s-this.value/100*s;this.indicatorOffset=`${d}px`}}render(){let t=this.ariaLabel;return t||(t=this.label?this.label:"Progress"),g`
      <div
        part="base"
        class=${u({"progress-ring":!0,"progress-ring--indeterminate":this.indeterminate,[`progress-ring--${this.labelPlacement}`]:!0})}
        role="progressbar"
        aria-label=${t}
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow="${this.indeterminate?0:this.value}"
        style="--percentage: ${this.indeterminate?0:this.value/100}"
      >
        <div class="progress-ring__container">
          <svg class="progress-ring__image">
            <circle class="progress-ring__track"></circle>
            <circle class="progress-ring__indicator" style="stroke-dashoffset: ${this.indicatorOffset}"></circle>
          </svg>
        </div>
        ${this.label||this.hasSlotController.test("[default]")?g`<span part="label" class="progress-ring__label">
              ${this.label?this.label:""}
              <slot></slot>
            </span>`:""}
      </div>
    `}};r.styles=c,r.baseName="progress-ring",r.reactEvents={},e([f(".progress-ring__indicator")],r.prototype,"indicator",2),e([h()],r.prototype,"indicatorOffset",2),e([i({type:Number,reflect:!0})],r.prototype,"value",2),e([i()],r.prototype,"label",2),e([i({type:Boolean,reflect:!0})],r.prototype,"indeterminate",2),e([i({attribute:"label-placement"})],r.prototype,"labelPlacement",2);var H=r;export{r as a,H as b};
